import { getCommonWidget } from '../../dashWidgetHelper'
import { commonWidgets, getHondaCustomerJourney, GREEN_1, HONDA_SCALE_3_COLORS, RED_1 } from '../commonWidgetsHonda'
import { answeredMapper, invalidMapper } from '../../dashHelper'

export default {
    title: 'Experiencia Honda Dashboard',
    description: 'Dashboard de perfil Honda',
    backgroundClassName: (filters) => 'epsilon-hero-bg',
    widgets: (filters: FiltersUI, filtersData: Record<string, any>) => {
        return [
            {
            title: 'labels.venta',
            type: 'label',
            position: [0, 0],
            size: [4, 1],
            //config: { color: '#B7AADC' },
            },

            //NPS GENERAL
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS General',
                size: [1, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'NPS_GENERAL',
                criticalMomentInclude: [13101],//this critical momenet id overwrits the others
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                
                extraConfigs: {
                    colors: HONDA_SCALE_3_COLORS,
                    useCurrent: 0,
                    categories: ['promoters', 'passives', 'detractors'],
                    categoriesLabel: ['Promotores', 'Neutros', 'Detractores'],
                    valueSymbol: '%',
                }
            }),

            //THIS ADDS TWO WIDGETS TO SHOW AVERAGE GENERAL FOR SAT AND NPS 
            //CSAT GENERAL
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Satisfacción General',
                size: [1, 2],
                indicator: 'CSAT_GENERAL',
                criticalMomentInclude: [13101],//this critical momenet id overwrits the others
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                  commonWidgets: commonWidgets,
                  name: 'gaugeGenericByStatus',
                  title: 'widgets.calidadDatosVenta',
                  position: [2, 1],
                  size: [1, 2],
                  url: 'survey-responses/values',
                  criticalMomentId: 13101,
                  mapper: invalidMapper,
                  extraConfigs: {
                    showPercentage: true,
                  },
                  render: (filters: FiltersUI) => {
                    return (
                      filters !== undefined &&
                      filters.criticalMoments !== undefined &&
                      filters.criticalMoments !== null &&
                      (filters.criticalMoments.includes(13101))
                    )
                  },
                }),
                getCommonWidget({
                  commonWidgets: commonWidgets,
                  name: 'gaugeGenericByStatus',
                  title: 'widgets.porcRespuestasVenta',
                  position: [3, 1],
                  size: [1, 2],
                  url: 'survey-responses/values',
                  criticalMomentId: 13101,
                  mapper: answeredMapper,
                  extraConfigs: {
                    showPercentage: true,
                  },
                  render: (filters: FiltersUI) => {
                    return (
                      filters !== undefined &&
                      filters.criticalMoments !== undefined &&
                      filters.criticalMoments !== null &&
                      (filters.criticalMoments.includes(13101))
                    )
                  },
                }),
            
            

            getHondaCustomerJourney({
                  id: 'cj-venta',
                  //position: [0, 12],
                  size: [4, 2],
                  indicators: [
                    //{ name: 'hon_vta_recibio_auto', formula: 'count-number' }, //csat
                    { name: 'hon_vta_atencion_rapida', formula: 'wavg-5' }, //atencion
                    { name: 'hon_vta_ejecutivo_vta_interesado', formula: 'wavg-5' },
                    { name: 'hon_vta_instal_agradables', formula: 'wavg-5' }, //facilidad
                    { name: 'hon_vta_prueba_agradable', formula: 'wavg-5' },
                    { name: 'hon_vta_finance_proceso_financiamiento', formula: 'wavg-5' },
                    { name: 'hon_vta_entrega_agil', formula: 'wavg-5' },
                  
                    { name: 'hon_vta_recibio_seguimiento', formula: 'wavg-5' },
                    //{ name: 'hon_vta_tanque_lleno', formula: 'count-number' },
                    //{ name: 'hon_vta_npm_satisf_gral', formula: 'nps-10' }, //nps
                    //{ name: 'hon_vta_npm_recom_prueba', formula: 'nps-10' }, //nps
                    //{ name: 'hon_vta_comment', formula: 'word-count' }, //?
                  ],
                  title: 'Proceso de venta',
                }),


    {
      title: 'labels.postventa',
      type: 'label',
      position: [0, 5],
      size: [4, 1],
      //config: { color: '#B7AADC' },
    },

            //NPS GENERAL
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS General',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'NPS_GENERAL',
                criticalMomentInclude: [13551],//this critical momenet id overwrits the others
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: HONDA_SCALE_3_COLORS,
                    useCurrent: 0,
                    categories: ['promoters', 'passives', 'detractors'],
                    categoriesLabel: ['Promotores', 'Neutros', 'Detractores'],
                    valueSymbol: '%',
                }
            }),

            //THIS ADDS TWO WIDGETS TO SHOW AVERAGE GENERAL FOR SAT AND NPS 
            //CSAT GENERAL
            /*
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Satisfacción General',
                size: [1, 2],
                indicator: 'CSAT_GENERAL',
                criticalMomentInclude: [13101],//this critical momenet id overwrits the others
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            */

            getCommonWidget({
                  commonWidgets: commonWidgets,
                  name: 'gaugeGenericByStatus',
                  title: 'widgets.calidadDatosVenta',
                  position: [2, 1],
                  size: [1, 2],
                  url: 'survey-responses/values',
                  criticalMomentId: 13551,
                  extraConfigs: {
                    showPercentage: true,
                  },
                  mapper: invalidMapper,
                  render: (filters: FiltersUI) => {
                    return (
                      filters !== undefined &&
                      filters.criticalMoments !== undefined &&
                      filters.criticalMoments !== null &&
                      (filters.criticalMoments.includes(13551))
                    )
                  },
                }),
                getCommonWidget({
                  commonWidgets: commonWidgets,
                  name: 'gaugeGenericByStatus',
                  title: 'widgets.porcRespuestasVenta',
                  position: [3, 1],
                  size: [1, 2],
                  url: 'survey-responses/values',
                  extraConfigs: {
                    showPercentage: true,
                  },
                  criticalMomentId: 13551,
                  mapper: answeredMapper,
                  render: (filters: FiltersUI) => {
                    return (
                      filters !== undefined &&
                      filters.criticalMoments !== undefined &&
                      filters.criticalMoments !== null &&
                      (filters.criticalMoments.includes(13551))
                    )
                  },
                }),


            getHondaCustomerJourney({
                  id: 'cj-postventa',
                  position: [0, 12],
                  size: [4, 2],
                  indicators: [
                    { name: 'hon_postvta_npm_prontitud_ingreso', formula: 'wavg' }, 
                    { name: 'hon_postvta_npm_conocimientos_asesor', formula: 'wavg' }, 
                    { name: 'hon_postvta_npm_tiempo_servicio', formula: 'wavg' },
                    { name: 'hon_postvta_npm_minuciosidad_trabajo', formula: 'wavg' },
                    { name: 'hon_postvta_npm_tiempo_administrativo', formula: 'wavg' },
                    { name: 'hon_postvta_npm_condicion_vehiculo_devuelto', formula: 'wavg' },                  

                  ],
                  title: 'Proceso de postventa',
                }),



    {
      title: 'labels.motospostventa',
      type: 'label',
      position: [0, 5],
      size: [4, 1],
      //config: { color: '#B7AADC' },
    },




            //NPS GENERAL
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS General',
                size: [1, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'hon_moto_pv_nps',
                criticalMomentInclude: [13554],//this critical momenet id overwrits the others
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: HONDA_SCALE_3_COLORS,
                    useCurrent: 0,
                    categories: ['promoters', 'passives', 'detractors'],
                    categoriesLabel: ['Promotores', 'Neutros', 'Detractores'],
                    valueSymbol: '%',
                }
            }),
            

            //THIS ADDS TWO WIDGETS TO SHOW AVERAGE GENERAL FOR SAT AND NPS 
            //CSAT GENERAL
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Satisfacción General',
                size: [1, 2]    ,
                indicator: 'hon_moto_pv_servicio_satisfactorio',
                criticalMomentId: 13554,
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                  commonWidgets: commonWidgets,
                  name: 'gaugeGenericByStatus',
                  title: 'widgets.calidadDatosVenta',
                  position: [2, 1],
                  size: [1, 2],
                  url: 'survey-responses/values',
                  criticalMomentId: 13554,
                  mapper: invalidMapper,
                  extraConfigs: {
                    showPercentage: true,
                  },
                  render: (filters: FiltersUI) => {
                    return (
                      filters !== undefined &&
                      filters.criticalMoments !== undefined &&
                      filters.criticalMoments !== null &&
                      (filters.criticalMoments.includes(13554))
                    )
                  },
                }),
                getCommonWidget({
                  commonWidgets: commonWidgets,
                  name: 'gaugeGenericByStatus',
                  title: 'widgets.porcRespuestasVenta',
                  position: [3, 1],
                  size: [1, 2],
                  url: 'survey-responses/values',
                  criticalMomentId: 13554,
                  mapper: answeredMapper,
                  extraConfigs: {
                    showPercentage: true,
                  },
                  render: (filters: FiltersUI) => {
                    return (
                      filters !== undefined &&
                      filters.criticalMoments !== undefined &&
                      filters.criticalMoments !== null &&
                      (filters.criticalMoments.includes(13554))
                    )
                  },
                }),





            getHondaCustomerJourney({
                  id: 'cj-motos-vp',
                  //position: [0, 12],
                  size: [4, 2],
                  indicators: [
                    { name: 'hon_moto_pv_npm_agendo_cita', formula: 'wavg' }, 
                    { name: 'hon_moto_pv_npm_eficiencia_recepcion', formula: 'wavg' }, 
                    { name: 'hon_moto_pv_npm_limpieza_unidad', formula: 'wavg' },
                    { name: 'hon_moto_pv_npm_servicio_valor', formula: 'wavg' },
                  ],
                  title: 'Proceso de postventa motos',
                }),





    {
      title: 'labels.comentarios',
      type: 'label',
      position: [0, 5],
      size: [4, 1],
      //config: { color: '#B7AADC' },
    },

/*

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGenericByStatus',
                title: 'Porcentaje de respuestas',
                indicator: 'general-respuestas-gauge',
                mapper: msurPorcRespuestasMapper,
                tooltipFormatter: msurTooltipTotalRegistros,
                size: [1, 2],
                //criticalMomentInclude: [getCmID('venta')],
                url: 'dashboard/status',
                extraIndicatorConfigs: {
                    keyExtract: ['resume'],
                    singleton: true
                },
                extras: {
                    useLcmApi: true,
                    //workflowName: 'posterior_dos'
                },
                extraConfigs: {
                    showPercentage: true,
                }
            }),
            */
    /*
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'wordCount',
                title: 'Comentarios',
                size: [4, 2],
                indicator: 'WORD_COUNT',
                mapper: (data: any, extra: any) => {
                    console.log(data);
                    const aux = data !== undefined
                    && data.map !== undefined
                    ? data.map((item: any) => ({
                        ...item,
                        group: item.group ?? item.category,
                        label: {...item.label, group: item.group ?? item.category}
                        }))
                    : [];
                    console.log(aux);
                    return aux;
                },
            }),
            */
{
    title: 'Nube de Palabras / Frecuencia en comentarios',
    position: [0, 13],
    size: [4, 2],
    config: {
      id: 'word-count',
      type: 'wordCloud',
      mapper: (data: any, extra: any) => {
        return data !== undefined
          && data.map !== undefined
          ? data.map((item: any) => ({
              ...item,
              group: item.group ?? item.category
            }))
          : []
      },
      indicators: [
        {
          indicator: 'WORD_COUNT',
          keyExtract: ['count', 'value', 'group','category'],
          singleton: true,
        },
      ],
    },
  },


            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'lastComments',
                size: [2, 4],
                indicator: 'COMMENTS',
                extraConfigs: {
                    maxCommentSize: 120,
                    layout: 'card',
                    geolocationLabelShow: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'rankingByTagBest',
                title: 'Sentimiento positivo con más frecuencia',
                size: [2, 2],
                indicator: 'SENTIMENT',
                extras: {
                    trunc: 'HALF_DOWN',
                    topSize: 3,
                },
                extraConfigs: {
                  layout: 'signal',
                  tone: 'positive',
                  headerBadge: 'Top',
                  countLabel: 'menciones',
                  color: GREEN_1,
                },
                extraIndicatorConfigs: {
                  limit: 2,
                  value: 'count',
                },
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'rankingByTagWorst',
                title: 'Temas a mejorar',
                size: [2, 2],
                indicator: 'SENTIMENT',
                extras: {
                    trunc: 'HALF_UP',
                    bottomSize: 3,
                },
                extraConfigs: {
                  layout: 'signal',
                  tone: 'negative',
                  headerBadge: 'Atención',
                  countLabel: 'menciones',
                  color: RED_1,
                },
                extraIndicatorConfigs: {
                  limit: 2,
                  value: 'count',
                },
            }),
            
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'diagramaIshikawa',
                title: 'Diagrama de Ishikawa',
                size: [4, 3],
                indicator: 'SENTIMENT',

            }),








        ]
    },
} as DasboardConfig
